import script from "./CampaignResult.vue?vue&type=script&lang=ts&setup=true"
export * from "./CampaignResult.vue?vue&type=script&lang=ts&setup=true"

import "./CampaignResult.vue?vue&type=style&index=0&id=a276c01a&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a276c01a"]])

export default __exports__